import { render } from "./OrderOptionsModal.vue?vue&type=template&id=b8c30e78&scoped=true"
import script from "./OrderOptionsModal.vue?vue&type=script&lang=js"
export * from "./OrderOptionsModal.vue?vue&type=script&lang=js"

import "./OrderOptionsModal.vue?vue&type=style&index=0&id=b8c30e78&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c30e78"]])

export default __exports__